<mbs-modal
  #modal
  class="max-hv-90"
  [isCustomModal]="true"
  [loading]="loading()"
  [showFooter]="true"
  [title]="'shared:licenses.renewLicenseModal.title' | i18next"
  [titleTextOverflow]="true">
  <div modal-body>
    <span class="d-block mt-2">
      @if (!totalUbWithDebt()) {
        {{
          'shared:licenses.renewLicenseModal.youAreGoingToRenew'
            | i18next: { licenses: totalLicenses() || 0, licensesCost: discountedPrice() | pricePrepayment | async }
        }}
      } @else {
        {{
          'shared:licenses.renewLicenseModal.youAreGoingToRenewWithStorages'
            | i18next
              : {
                  licenses: totalLicenses() || 0,
                  licensesCost: discountedPrice() | pricePrepayment | async,
                  storages: totalUbWithDebt(),
                  storagesCost: storagesTotalCost() | pricePrepayment | async
                }
        }}
      }
    </span>

    <span class="d-block mt-2 mb-4">
      {{ 'shared:licenses.renewLicenseModal.totalAmount' | i18next: { money: totalAmount() | pricePrepayment | async } }}
    </span>

    @if (isNotEnoughCreditsToPay() && isPaymentLessThanOneDollar()) {
      <span class="d-block mt-2">{{ 'shared:licenses.renewLicenseModal.minimalPayment' | i18next: { money: 1 } }}</span>
      <span class="d-block mt-2">{{
        'shared:licenses.renewLicenseModal.willBeReturnedToYourAccountInCredits' | i18next: { money: total() }
      }}</span>
    }

    @if (isNotEnoughCreditsToPay() && !isPaymentLessThanOneDollar() && balanceValue()) {
      <span class="d-block mt-2">{{
        'shared:licenses.renewLicenseModal.youHaveInYourAccount' | i18next: { money: balanceValue() | pricePrepayment | async }
      }}</span>
      <span class="d-block mt-2">{{
        'shared:licenses.renewLicenseModal.theCostOfRenewalIs' | i18next: { money: total() | pricePrepayment | async }
      }}</span>
    }

    @if (!isNotEnoughCreditsToPay()) {
      <span class="d-block mt-2">{{
        'shared:licenses.renewLicenseModal.youHaveInYourAccount' | i18next: { money: balanceValue() | pricePrepayment | async }
      }}</span>
      <span class="d-block mt-2">{{
        'shared:licenses.renewLicenseModal.theEntirePaymentWillBePaidInCredits'
          | i18next: { money: balanceValue() | pricePrepayment | async }
      }}</span>
    }

    <span class="d-block mt-2 mb-2"> {{ 'shared:licenses.renewLicenseModal.autoRenewalWillBeEnabledForThemAutomatically' | i18next }}</span>

    @if (wasabiStoragesInfo()?.length || awsStoragesInfo()?.length) {
      <h5>
        @if (storageBillingPeriods(); as periods) {
          {{
            'shared:licenses.renewLicenseModal.storageTitle'
              | i18next: { count: periods.count, periods: periods.label, subscription: subscriptionTypeKey() | i18next }
          }}
        } @else {
          {{ 'shared:licenses.renewLicenseModal.storage' | i18next }}
        }
      </h5>
    }

    @if (wasabiStoragesInfo()?.length) {
      <mbs-wasabi-table
        [licenses]="wasabiStoragesInfo()"
        [tableMaxHeight]="null"
        [total]="wasabiStoragesTotalCost()">
      </mbs-wasabi-table>
    }

    @if (awsStoragesInfo()?.length) {
      <div class="mt-3">
        <mbs-aws-table
          [licenses]="awsStoragesInfo()"
          [tableMaxHeight]="null"
          [total]="awsStoragesTotalCost()"></mbs-aws-table>
      </div>
    }

    <h5 class="mt-3">
      @if (licensesBillingPeriods(); as periods) {
        {{
          'shared:licenses.renewLicenseModal.licensesTitle'
            | i18next: { count: periods.count, periods: periods.label, subscription: subscriptionTypeKey() | i18next }
        }}
      } @else {
        {{ 'shared:licenses.renewLicenseModal.licenses' | i18next }}
      }
    </h5>

    <mbs-renewal-table
      [isProratedColumnShown]="true"
      [licenses]="licensesInfo()?.licenses"
      [tableMaxHeight]="null"></mbs-renewal-table>

    @if (licensesInfo()?.listPrice) {
      <div class="d-flex justify-content-between mt-3">
        <div class="col-9">
          @if (minCommitment()) {
            <span
              [innerHTML]="
                'shared:licenses.renewLicenseModal.minimumPayment'
                  | i18next
                    : {
                        period: paymentPeriodKey() | i18next,
                        money: minCommitment() | pricePrepayment: null : null | async
                      }
              "></span>
          }
        </div>
        <div class="col-3 pr-2">
          @if (minCommitment() && showMinCommitment()) {
            <div class="row justify-content-between mt-2">
              <div class="col-auto">{{ 'shared:licenses.renewLicenseModal.minimumFee' | i18next }}</div>
              <div class="col-auto">{{ minCommitment() | pricePrepayment | async }}</div>
            </div>
          }
          <div
            class="row justify-content-between"
            [ngClass]="{ 'mt-3': showMinCommitment() }">
            <div class="col-auto">{{ 'shared:licenses.renewLicenseModal.listPrice' | i18next }}</div>
            <div class="col-auto">{{ licensesInfo()?.listPrice | pricePrepayment | async }}</div>
          </div>
          <div class="row justify-content-between mt-2">
            <div class="col-auto">{{ 'shared:licenses.renewLicenseModal.proratedPrice' | i18next }}</div>
            <div class="col-auto position-relative">
              {{ licensesInfo()?.proratedPrice | pricePrepayment | async }}

              <i
                class="fa fa-question-circle text-gray-400 hint"
                container="body"
                [ngbTooltip]="'shared:licenses.prepayment.prorated' | i18next">
              </i>
            </div>
          </div>
          <div class="row justify-content-between mt-2">
            <div class="col-auto">{{ 'shared:licenses.renewLicenseModal.discount' | i18next }}</div>
            <div class="col-auto">{{ licensesInfo()?.discount | pricePrepayment | async }}</div>
          </div>
          @if (balanceValue()) {
            <div class="row justify-content-between mt-2">
              <div class="col-auto">{{ 'shared:licenses.renewLicenseModal.credits' | i18next }}</div>
              <div class="col-auto">{{ balanceValue() | pricePrepayment | async }}</div>
            </div>
          }
          <div class="row justify-content-between mt-2">
            <div class="col-auto">
              <b>{{ 'shared:licenses.renewLicenseModal.total' | i18next }}</b>
            </div>
            <div class="col-auto position-relative">
              <b
                >{{ total() | pricePrepayment | async }}
                <i
                  class="fa fa-question-circle text-gray-400 hint"
                  container="body"
                  [ngbTooltip]="
                    'shared:licenses.renewLicenseModal.minimumMonthlyFee'
                      | i18next
                        : {
                            minCommitment: minCommitment() | pricePrepayment: null : null | async,
                            period: paymentPeriodKey() | i18next
                          }
                  ">
                </i>
              </b>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="renewLoading()"
      (click)="renew()"
      >{{ 'shared:licenses.renewLicenseModal.submit' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >{{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
